import { ReportState } from '.';
import { GetterTree } from 'vuex';
import { AppState } from '../app';

export const getters: GetterTree<ReportState, AppState> = {
  getReportLabels(state: ReportState) {
    return (reportId: string) => {
      return state.labels[reportId];
    };
  },
  selectedDateOption(state: ReportState) {
    return state.selectedDateOption;
  },
  selectedFlowId(state: ReportState) {
    return state.selectedFlowId;
  },
  reportFlowsOptions(state: ReportState) {
    return state.flowListOptions;
  },
  isReportLoading(state: ReportState) {
    return state.isReportLoading;
  },
};
